import { Component } from '@angular/core';
import { Layout } from 'app/views/presentations/layouts/layout';
import { LayoutComponent } from 'app/views/presentations/layouts/layout.component';

@Component({
    selector: `psm-two-sections-vertical-layout-mirror-component`,
    templateUrl: 'twoSectionsVerticalLayoutMirror.component.html',
    styleUrls: ['../layout.component.scss']
})

export class TwoSectionsVerticalLayoutMirrorComponent extends LayoutComponent { }

export class TwoSectionsVerticalLayoutMirror extends Layout {
    public type = 'TwoSectionsVerticalLayoutMirror';
    public componentType = TwoSectionsVerticalLayoutMirrorComponent;
    public numberOfSections = 2;
}


// WEBPACK FOOTER //
// ./src/app/views/presentations/layouts/layouts/twoSectionsVerticalLayoutMirror/twoSectionsVerticalLayoutMirror.component.ts